import { render, staticRenderFns } from "./RubricPreset.vue?vue&type=template&id=43d98361&scoped=true"
import script from "./RubricPreset.vue?vue&type=script&lang=js"
export * from "./RubricPreset.vue?vue&type=script&lang=js"
import style0 from "./RubricPreset.vue?vue&type=style&index=0&id=43d98361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d98361",
  null
  
)

export default component.exports